import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getHomepageSectionML } from '../../services/api';
import StatBlock from '../common/StatBlock';

const StatsSectionML = () => {
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStatsContent();
  }, [language]);

  const loadStatsContent = async () => {
    setLoading(true);
    const normalizedLang = ['pt','en','fr','ar','zh'].includes(language) ? language : (language.startsWith('pt') ? 'pt' : 'en');
    const result = await getHomepageSectionML('stats', normalizedLang);
    if (result.success) {
      setContent(result.data);
    }
    setLoading(false);
  };

  if (loading || !content) {
    return (
      <section
        className="py-20"
        style={{
          background: 'linear-gradient(135deg, #023E8A 0%, #00B4D8 100%)'
        }}
      >
        <div className="container mx-auto px-6 text-center text-white">
          <div className="animate-pulse">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="py-20"
      style={{
        background: 'linear-gradient(135deg, #023E8A 0%, #00B4D8 100%)'
      }}
    >
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {content.stats?.map((stat, index) => (
            <StatBlock key={index} number={stat.number} label={stat.label} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSectionML;
